import React, { useState } from 'react';

const ProblemApproval = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [entries, setEntries] = useState(10);
  
  const problemData = [
    {
      srNo: 1,
      mobileNo: '7905531654',
      proof: '',
      referenceNo: '99A178A7AD4C3A4851A87DAA5E8DA5',
      problem: 'Membership amount of 1000/- is not showing in ODH Money',
      remark: 'Your problem is already resolved',
      status: 'Approved',
      issueDate: '05-07-2021',
      resolveDate: '05-07-2021',
      txn: 'TKN_165419529182',
    },
    // You can add more rows as needed
  ];

  const filteredData = problemData.filter((item) =>
    item.mobileNo.includes(searchTerm)
  );

  const handleEntriesChange = (e) => {
    setEntries(parseInt(e.target.value, 10));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEditClick = (txn) => {
    console.log('Editing transaction:', txn);
    // Handle the edit functionality here (e.g., opening a modal or navigating to an edit page)
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '12px',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  const selectStyle = {
    padding: '6px',
    fontSize: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  };

  const buttonStyle = {
    padding: '6px 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px' }}>
        Problem Approval
      </h2>

      {/* Filter Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div>
          <label style={{ marginRight: '10px' }}>Show</label>
          <select
            style={selectStyle}
            value={entries}
            onChange={handleEntriesChange}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <label style={{ marginLeft: '10px' }}>entries</label>
        </div>
        <div>
          <input
            type="text"
            placeholder="Search by Mobile No."
            value={searchTerm}
            onChange={handleSearchChange}
            style={selectStyle}
          />
        </div>
      </div>

      {/* Table displaying problems */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Proof</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Reference No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Problem</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Remark</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Issue Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Resolve Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>TXN</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.slice(0, entries).map((item) => (
            <tr key={item.srNo}>
              <td style={thTdStyle}>{item.srNo}</td>
              <td style={thTdStyle}>{item.mobileNo}</td>
              <td style={thTdStyle}>{item.proof}</td>
              <td style={thTdStyle}>{item.referenceNo}</td>
              <td style={thTdStyle}>{item.problem}</td>
              <td style={thTdStyle}>{item.remark}</td>
              <td style={thTdStyle}>{item.status}</td>
              <td style={thTdStyle}>{item.issueDate}</td>
              <td style={thTdStyle}>{item.resolveDate}</td>
              <td style={thTdStyle}>{item.txn}</td>
              <td style={thTdStyle}>
                <button
                  style={buttonStyle}
                  onClick={() => handleEditClick(item.txn)}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProblemApproval;
